"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_dom_1 = tslib_1.__importDefault(require("react-dom"));
const __1 = require("..");
const styling_1 = require("../../../styling");
const utils_1 = require("../../../styling/utils");
const Close_1 = tslib_1.__importDefault(require("../../../ui-lib/Buttons/Close"));
const SlidingShelf_1 = tslib_1.__importDefault(require("../../../ui-lib/SlidingShelf"));
const SendCallRequest_1 = tslib_1.__importDefault(require("../Buttons/Encoder/SendCallRequest"));
const callRequestSidebarStyles_1 = tslib_1.__importDefault(require("./callRequestSidebarStyles"));
const CallRequestSidebar = ({ attachToRef, classes = {}, ref, children, open = false, renderTitle, title, onRequestButtonClick, buttonRequestText, onCloseButtonClick, renderButton, ...props }) => {
    if (!attachToRef) {
        // eslint-disable-next-line no-console
        console.warn("VideoCallSidebar was not provided the attachToRef prop. This is used to attach to a DOM element and display the sidebar.");
        return null;
    }
    const [localOpen, setLocalOpen] = (0, react_1.useState)(open);
    (0, react_1.useEffect)(() => {
        setLocalOpen((previousOpenState) => {
            if (previousOpenState != open) {
                return open;
            }
            return previousOpenState;
        });
    }, [open]);
    const mergedClasses = (0, styling_1.useStyles)({ source: classes, target: callRequestSidebarStyles_1.default }, "callRequestSidebar");
    const mergedStyles = (0, utils_1.mergeStylesObjects)(classes, {});
    const closeHandler = () => {
        setLocalOpen(false);
        onCloseButtonClick ? onCloseButtonClick() : null;
    };
    const renderSidebarButton = () => renderButton ? (renderButton(props)) : (react_1.default.createElement("div", { className: mergedClasses.buttonContainer },
        react_1.default.createElement(SendCallRequest_1.default, { ref: ref, buttonRequestText: buttonRequestText !== null && buttonRequestText !== void 0 ? buttonRequestText : undefined, onRequestButtonClick: onRequestButtonClick, active: false, disabled: false, isFirstAttempt: true })));
    const renderModularSlide = () => (react_1.default.createElement(SlidingShelf_1.default, { classes: classes === null || classes === void 0 ? void 0 : classes.slideSidebar, open: localOpen },
        react_1.default.createElement("div", { className: mergedClasses.headerContainer },
            react_1.default.createElement(Close_1.default, { onClick: closeHandler, open: localOpen, classes: mergedStyles.closeButton }),
            renderTitle ? renderTitle(props) : react_1.default.createElement("span", { className: mergedClasses.renderTitleSpan }, title)),
        react_1.default.createElement("div", { className: mergedClasses.callRequestContainer },
            react_1.default.createElement("div", { className: mergedClasses.encoderContainer },
                react_1.default.createElement(__1.EncoderVideo, { classes: mergedStyles.videoWrapper })),
            react_1.default.createElement("div", { className: mergedClasses.deviceSelectContainer },
                react_1.default.createElement("p", { className: mergedClasses.settingsText }, "Settings"),
                react_1.default.createElement(__1.EncoderVideoDeviceSelect, { ariaLabel: "Video device select", classes: mergedStyles.videoDeviceSelect }),
                react_1.default.createElement(__1.EncoderAudioDeviceSelect, { ariaLabel: "Audio device select", classes: mergedStyles.audioDeviceSelect })),
            renderSidebarButton())));
    return react_dom_1.default.createPortal(renderModularSlide(), attachToRef);
};
exports.default = CallRequestSidebar;
//# sourceMappingURL=CallRequestSidebar.js.map